import React from 'react';
import Icon from '../../../components/AppIcon';

const points = [
  {
    icon: 'Gauge',
    title: 'See the limit before you choose',
    description: 'Every plan shows its monthly submission allowance up front, so you can pick the capacity your forms need.',
  },
  {
    icon: 'Users',
    title: 'Bring the whole team',
    description: 'Paid plans include unlimited seats, so your marketing, sales, and operations teams can work from one account.',
  },
  {
    icon: 'BellRing',
    title: 'Plan your next step',
    description: 'Review submission activity in your dashboard and move to a higher-capacity plan when your forms start to grow.',
  },
];

const ResponseCapSection = () => {
  return (
    <section className="py-16 sm:py-20 bg-[#f7fbfb] border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-[1.05fr_1fr] gap-10 lg:gap-16 items-center">
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-teal-50 border border-teal-200 rounded-full text-xs font-semibold text-teal-700 mb-5">
              <Icon name="ShieldCheck" size={13} />
              <span>Pricing you can plan around</span>
            </div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold text-gray-900 leading-tight mb-4">
              No more response-cap anxiety
            </h2>
            <p className="text-base sm:text-lg text-gray-600 leading-relaxed max-w-xl">
              Know what each plan includes before you publish. WebForms.biz makes capacity visible, so growing teams can focus on the leads coming in instead of guessing what their forms can handle.
            </p>
          </div>

          <div className="grid gap-4">
            {points.map((point) => (
              <div key={point.title} className="flex items-start gap-4 p-4 sm:p-5 rounded-2xl bg-white border border-gray-200 shadow-sm">
                <div className="w-10 h-10 rounded-xl bg-teal-50 border border-teal-100 flex items-center justify-center flex-shrink-0">
                  <Icon name={point.icon} size={18} className="text-[#0e7572]" />
                </div>
                <div>
                  <h3 className="text-base font-semibold text-gray-900 mb-1">{point.title}</h3>
                  <p className="text-sm text-gray-500 leading-relaxed">{point.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResponseCapSection;